/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { TextField, Button, Typography, Alert } from '@mui/material';

const baseUrl = `${process.env.SERVER_URL ?? 'http://localhost:3000'}/api`;

const ResetPassword = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [email, setEmail] = useState('');
  const [tokenValid, setTokenValid] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const { token } = useParams();

  useEffect(() => {
    const validateResetPasswordLink = async () => {
      if (token) {
        try {
          const response = await axios.get(
            `${baseUrl}/auth/validate-reset-password/${token}`,
          );
          setEmail(response.data.email);
          setTokenValid(true);
        } catch (err: any) {
          setError(err.response?.data?.message || 'Invalid or expired token.');
          setEmail(err.response.data.email);
          setTokenValid(false);
        } finally {
          setIsLoading(false);
        }
      }
    };

    validateResetPasswordLink();
  }, []);

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    setMessage('');
    setError('');

    if (password !== confirmPassword) {
      setError("Passwords don't match");
      return;
    }

    try {
      const response = await axios.post(`${baseUrl}/auth/reset-password`, {
        token,
        password,
        confirmPassword,
      });
      setMessage(
        response.data.message || 'Password has been reset successfully',
      );
      // Optionally navigate the user to the login page after a delay
      setTimeout(() => navigate('/login'), 3000);
    } catch (err: any) {
      setError(
        err.response?.data?.message ||
          'An error occurred while resetting the password.',
      );
    }
  };

  const handleResendEmail = async () => {
    try {
      await axios.post(`${baseUrl}/auth/forgot-password`, {
        email,
      });
      setMessage('Password reset email sent.');
      setError('');
    } catch (err) {
      setError('Failed to resend email.');
    }
  };

  return (
    <div style={{ maxWidth: '320px', margin: 'auto' }}>
      <Typography variant="h4" gutterBottom>
        Reset Password
      </Typography>
      {message && (
        <Alert severity="success" sx={{ mb: 2 }}>
          {message}
        </Alert>
      )}
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      {isLoading ? (
        <Typography>Loading...</Typography>
      ) : tokenValid ? (
        <form onSubmit={handleSubmit}>
          <TextField
            id="password"
            label="New Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
            required
            sx={{ mb: 2 }}
          />
          <TextField
            id="confirmPassword"
            label="Confirm New Password"
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            fullWidth
            required
            sx={{ mb: 2 }}
          />
          <Button type="submit" variant="contained" color="primary">
            Reset Password
          </Button>
        </form>
      ) : (
        <div>
          <TextField
            fullWidth
            required
            sx={{ mb: 2 }}
            id="email"
            name="email"
            label="Email"
            type="email"
            disabled
            value={email}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={handleResendEmail}
          >
            Resend Email
          </Button>
        </div>
      )}
    </div>
  );
};

export default ResetPassword;
